<template>
  <div class="docuforms-page">
    <DocuformsList/>
  </div>
</template>

<script>
import DocuformsList from "../components/DocuformsList";

export default {
  name: "DocuformsPage",
  components: {DocuformsList}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.docuforms-page {
  height: 100vh;
  background-color: $grey-color-1;

  @include md-and-up {
    padding: 24px 24px 0;
    padding-inline-end: 44px;
  }
}
</style>
